import { render, staticRenderFns } from "./DispatchDetailedLoadTable.vue?vue&type=template&id=0d9fe6ca&scoped=true&"
import script from "./DispatchDetailedLoadTable.vue?vue&type=script&lang=js&"
export * from "./DispatchDetailedLoadTable.vue?vue&type=script&lang=js&"
import style0 from "./DispatchDetailedLoadTable.vue?vue&type=style&index=0&id=0d9fe6ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9fe6ca",
  null
  
)

export default component.exports